export class BaseConfig {
  static styleParam = {
    dynamicForm: {
      type: "default",
      size: "sm",
    },
    listPage: {},
    table: {
      type: "default",
      size: "default",
    },
  };

  static config = {
    languageEnv: "zhCN", //zhCN/enUS   中文/英文
    component: {
      rightDebug: true, // 基础组件的右键数据源功能 - 开发专用
    },
    dynamicForm: {
      labelLength: 6, //表单label默认截取的字符长度
    },
    //表单项默认宽度分配参数
    formItemLayout: {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    },
    listPage: {
      //查询栏公共参数
      searchPanel: {
        defaultFold: false, //查询栏折叠收起的默认状态， 为false则默认收起， 否则默认打开折叠状态
        keepSearchParam: false, //是否保存查询缓存项，如果开启，则查询栏会以tag的形式缓存查询条件
      },
      resetModel: "remote", //重置模式，remote/local   ，  一个刷新组件，一个不刷新组件
      pageSize: 10, // 表格分页大小
      keep: false, // 是否开启缓存
      keepTrigger: "change", // 缓存时机  change/submit
      superRender: false, //是否开启强渲染模式， 在该模式下， 可以解决很多表格对不齐的问题，但是可能会消耗一定性能
      pageSizeOptions: ["10", "20", "30", "40", "50"],
    },
    table: {
      authority: false, //开启权限过滤
      resizable: {
        status: false,
        type: "row", //row 作用于整行，col作用于列ps：可以配置指定列拖动配合column.resizable = boolean
      },
      childrenColumnName: "children", // 树表的取值字段
      styleParam: {
        //样式风格
        size: "default", //表格默认大小  default/sm/large
      },
      btnVertical: "top", // 表格批量按钮的默认定位，top：表格上面，panel：当面板存在时，面板右边，bottom：表格底部,
      column: {
        serialNumber: 50,
      },
      editable: {
        editing: false, // 可编辑表格的时候，编辑框的默认是否开启状态。
      },
      isSimple: false /* 默认关闭分页简单模式 */,
      noPanel: false /* 默认关闭noPanel */,
    },
    action: {
      isConfirm: false, //是否为确认操作按钮
    },
    icon: {
      scriptUrl: null, // icon组件的iconfont地址
    },
    check: true, // 表示是否开启组件参数校验
    button: {
      size: "default", // button的默认大小风格
    },
    iconFontUrls: {
      yxWidget: "//at.alicdn.com/t/font_1643396_hn8gjuhpxbq.js", //'//at.alicdn.com/t/font_1643396_n26v76q19w.js'
    },
    input: {
      defaultInputMax: 50, // input默认最大限制长度
      cascader: {
        dataPath: "data", // 级联默认取值路径
      },
    },
    language: {}, // 扩展额外语言包， 具体项参考组件语言包， 和languageEnv对应键名即可扩展新的语言包
    //请求接口的配置
    request: {
      message: true, //是否使用默认错误提示
    },
    //元数据配置数据
    metadataDict: {
      //元数据，字段类型对应前端组件类型映射
      fieldType: [
        { server: "integer", front: "Number" }, //整数
        { server: "decimal", front: "Number" }, //小数
        { server: "money", front: "Number" }, //金额
        { server: "varchar", front: "String" }, //文本
        { server: "text", front: "TextArea" }, //文本域
        { server: "email", front: "EMail" }, //邮箱
        { server: "bool", front: "Select" }, //布尔
        { server: "date", front: "Date" }, //日期
        { server: "datetime", front: "Date" }, //日期时间
      ],
      // 实体元数据查询接口
      entityRequestParam: {
        url: "data-object",
      },
      //查询应用列表
      appRequestParam: {
        url: "app",
      },
      //查询元数据版本
      mateVersionRequestParam: {
        url: "mate/version",
      },
      //查询元数据详情
      entityInfoRequestParam: {
        url: "data-object/{id}/for-page",
      },
    },
    embeddedRender: {
      url: "/EmbeddedRender" /* iframe 页面router地址 */,
      pathName: "pathName" /* iframe 地址 */,
    },
  };
}

export default BaseConfig.config;



// WEBPACK FOOTER //
// ./src/yx-widget/config/index.js